import { createUseStyles, Styles } from '@pff-consumer/tweed-ui/web-styles'

interface CheckoutErrorModalStyles {
  link: Styles
}

export const useStyles = createUseStyles<CheckoutErrorModalStyles>(() => {
  return {
    link: {
      color: '#3388FF',
      textDecoration: 'underline',
    },
  }
})
